export enum UserAction {
  RightKey = 39,
  LeftKey = 37,
  UpKey = 38,
  DownKey = 40
}
